<div class="delete-modal-backdrop" *ngIf="visible" @backdropAnim (click)="onCancel()">
  <div class="delete-modal-card" @cardAnim (click)="$event.stopPropagation()">
    <button class="delete-modal-close" (click)="onCancel()">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 1L1 13M1 1L13 13" stroke="#ADADAD" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </button>
    <h3 class="delete-modal-title">Delete {{ itemType }}</h3>
    <p class="delete-modal-message">
      You're about to delete <strong>{{ itemName }}</strong> from your store, Are you sure?
    </p>
    <button class="delete-modal-confirm-btn" (click)="onConfirm()">Delete {{ itemType }}</button>
    <button class="delete-modal-cancel-btn" (click)="onCancel()">Cancel</button>
  </div>
</div>
